import styled from "styled-components";
import PaginatedTable from "../../Componentes/Utils/PaginatedTable";
import { useEffect, useState } from "react";
import useApi from "../../hooks/useApi";
import { formatCurrency } from "../../Funcoes/formatCurrency";

import { RiRefreshLine } from "react-icons/ri";
import { MdOutlineFileDownload } from "react-icons/md";
import { HiFilter } from "react-icons/hi";
import { useModal } from "../../contexts/ModalContext";
import ModalFilters from "./ModalFilters";

const Container = styled.div`
    width: 100%;
    height: 100%;
    overflow: hidden;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
`
const Header = styled.div`
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    border-bottom: 1.2px solid #d3d3d3;
    box-sizing: border-box;
`
const BodyWrapper = styled.div`
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 15px;
    box-sizing: border-box;
`
const StatisticsWrapper = styled.div`
    width: 100%;
    height: 80px;
    display: flex;
    gap: 5px;
    flex-shrink: 0;
    border-radius: 8px;
    border: 1.2px solid #d3d3d3;
    background-color: #f0f0f0;
    padding: 5px;
    box-sizing: border-box;
    justify-content: flex-end;
`
const Card = styled.div`
    height: 100%;
    padding: 0 35px 0 15px;
    border-radius: 13px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
`
const CardValue = styled.p`
    font-size: 18px;
    font-weight: bold;
    color: #333;
    margin: 0;
    margin: auto 0 0 0;
`
const CardLabel = styled.p`
    font-size: 12px;
    color: #555;
    margin: 0;
    margin: 0 0 auto 0;
`
const Title = styled.p`
    color: #333;
    font-size: 16px;
    font-weight: bold;
    margin: auto 0 auto 15px;
`
const ActionsWrapper = styled.div`
    height: 30px;
    margin-left: auto;
    margin-right: 15px;
    display: flex;
    gap: 10px;
    align-items: center;

    & button{
        height: 100%;
        padding: 0 15px;
        border: 1.2px solid #d3d3d3;
        border-radius: 4px;
        background-color: transparent;
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    & button:hover{
        background-color: #f0f0f0;
    }
`
const Body = styled.div`
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: #fff;
    margin-top: 5px;
    border-radius: 8px;
    border: 1.2px solid #d3d3d3;
    box-sizing: border-box;
`
const FilterIcon = styled(HiFilter)`
    width: 18px;
    height: 18px;
    color: #333;
    margin-right: 8px;
`
const RefreshIcon = styled(RiRefreshLine)`
    width: 15px;
    height: 15px;
    color: #333;
    margin-right: 8px;
    animation: ${props => props.loading ? 'spin 1s linear infinite' : 'none'};

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`
const DownloadIcon = styled(MdOutlineFileDownload)`
    width: 17px;
    height: 17px;
    color: #333;
    margin-right: 8px;
`

const Coluna = styled.td`
    text-align: ${({ align }) => align || 'left'};
`

const PedidosCompra = () => {

    const api = useApi();
    const { isModalOpen, openModal, closeModal } = useModal();

    const [pagina, setPagina] = useState(1);
    const [loading, setLoading] = useState(false);

    const [dados, setDados] = useState([]);
    const [valorTotal, setValorTotal] = useState("0,00");
    const [valorEntregue, setValorEntregue] = useState("0,00");
    const [totalItems, setTotalItems] = useState(0);
    const [totalPages, setTotalPages] = useState(0);

    const [ filtros, setFiltros ] = useState({
        dataInicio: '',
        dataFim: ''
    })

    const fetchDados = async ( page = pagina, curFiltros = filtros ) => {
        setLoading(true);

        try {

            const params = new URLSearchParams();
            params.append('page', page);
            params.append('limit', 50);

            if( curFiltros.dataInicio ) params.append('data_inicio', curFiltros.dataInicio);
            if( curFiltros.dataFim ) params.append('data_fim', curFiltros.dataFim);

            const { data } = await api.get(`Painel/API/Controladoria/index.php?${params.toString()}`);
            setDados(data.data);
            setTotalItems(data.quantidade)
            setTotalPages(data.total_pages)
            setValorTotal(data.valor_geral)
            setValorEntregue(data.valor_entregue)

            console.log(data);

        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {

        fetchDados( pagina, filtros );

    }, [pagina]);

    const [ refreshing, setRefreshing ] = useState( false );

    const refreshData = async () => {

        if( refreshing ) return;

        setRefreshing( true );
        await fetchDados();
        setRefreshing( false );

    }

    const aplicarFiltros = () => {

        setPagina(1);
        fetchDados(1, filtros);

    }

    const OpenFilters = () => {

        openModal('controladoria-filtros');

    }

    return (
        <>
            <Container>
                <Header>
                    <Title>Pedidos de Compra</Title>
                    <ActionsWrapper>
                        <button onClick={ refreshData } >
                            <RefreshIcon
                                loading={ refreshing }
                            />
                            Atualizar
                        </button>
                        <button onClick={ OpenFilters }>
                            <FilterIcon />
                            Gerenciar Filtros
                        </button>
                        <button>
                            <DownloadIcon />
                            Exportar Excel
                        </button>
                    </ActionsWrapper>
                </Header>
                <BodyWrapper>
                    <StatisticsWrapper>
                        <Card>
                            <CardValue>{totalItems}</CardValue>
                            <CardLabel>Total de Pedidos</CardLabel>
                        </Card>
                        <Card>
                            <CardValue>R$ {valorTotal}</CardValue>
                            <CardLabel>Valor Total</CardLabel>
                        </Card>
                        <Card>
                            <CardValue>R$ {valorEntregue}</CardValue>
                            <CardLabel>Valor Entregue</CardLabel>
                        </Card>
                    </StatisticsWrapper>
                    <Body>
                        <PaginatedTable
                            pagina={pagina}
                            setPagina={setPagina}
                            loading={loading}
                            colunas={15}
                            totalItems={totalItems}
                            totalPages={totalPages}
                            thead={
                                <tr>
                                    <th>FILIAL</th>
                                    <th>DATA EMISSÃO</th>
                                    <th>FORNECEDOR</th>
                                    <th>NUM. PEDIDO</th>
                                    <th>ITEM</th>
                                    <th>PRODUTO</th>
                                    <th>DESCRIÇÃO</th>
                                    <th>UNIDADE</th>
                                    <th>QUANTIDADE</th>
                                    <th>PREÇO UNITARIO</th>
                                    <th>VALOR DESCONTO</th>
                                    <th>VALOR IPI</th>
                                    <th>VALOR FRETE</th>
                                    <th>VALOR DESPESAS</th>
                                    <th>VALOR TOTAL</th>
                                    <th>ITEM CONTA</th>
                                    <th>ARMAZEM</th>
                                    <th>CENTRO CUSTO</th>
                                    <th>DATA ENTREGA</th>
                                    <th>NUM. S.A.</th>
                                    <th>NUM. SC</th>
                                    <th>ITEM SC</th>
                                    <th>QTDE. SC</th>
                                    <th>NUM. CA</th>
                                    <th>VENC. CA</th>
                                    <th>OBS</th>
                                    <th>OBS FINANC.</th>
                                    <th>COND. PAGAMENTO</th>
                                    <th>CTA. CONTABIL</th>
                                    <th>USUÁRIO INC</th>
                                    <th>PLACA</th>
                                    <th>PLACA 2</th>
                                    <th>GRUPO</th>
                                    <th>QTD. ENTREGUE</th>
                                    <th>RESID. ELIMIN.</th>
                                    <th>GRUPO APROV.</th>
                                    <th>CONTROLE AP.</th>
                                </tr>
                            }
                        >
                            <tbody>
                                {
                                    dados.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.FILIAL}</td>
                                            <td>{item.DATA_EMISSAO}</td>
                                            <td>{item.NOME_FORNECEDOR}</td>
                                            <td>{item.NUM_PEDIDO}</td>
                                            <td>{item.C7_ITEM}</td>
                                            <td>{item.COD_PRODUTO}</td>
                                            <td>{item.DESCRICAO}</td>
                                            <Coluna align="center">{item.UNIDADE}</Coluna>
                                            <Coluna align="right">{item.QUANTIDADE}</Coluna>
                                            <Coluna align="right">{"R$ " + formatCurrency(item.PRC_UNIT)}</Coluna>
                                            <Coluna align="right">{"R$ " + formatCurrency(item.VLR_DESCONTO)}</Coluna>
                                            <Coluna align="right">{"R$ " + formatCurrency(item.VLR_IPI)}</Coluna>
                                            <Coluna align="right">{"R$ " + formatCurrency(item.VLR_FRETE)}</Coluna>
                                            <Coluna align="right">{"R$ " + formatCurrency(item.VLR_DESPESAS)}</Coluna>
                                            <Coluna align="right">{item.VLR_TOTAL ? "R$ " + formatCurrency(item.VLR_TOTAL) : ''}</Coluna>
                                            <td>{ item.ITEM_CONTA }</td>
                                            <td>{ item.ARMAZEM }</td>
                                            <td>{ item.CENTRO_CUSTO }</td>
                                            <td>{ item.ENTREGA }</td>
                                            <td>{ item.NR_SA ? item.NR_SA : ' - ' }</td>
                                            <td>{ item.NR_SC ? item.NR_SC : ' - ' }</td>
                                            <td>{ item.ITEM_SC ? item.ITEM_SC : ' - ' }</td>
                                            <td>{ item.QTD_SC }</td>
                                            <td>{ item.NUM_CA ? item.NUM_CA : ' - ' }</td>
                                            <td>{ item.VENC_CA ? item.VENC_CA : ' - ' }</td>
                                            <td>{ item.OBSERVACOES ? item.OBSERVACOES : ' - ' }</td>
                                            <td>VERIFICAR</td>{ /* OBS FINANCEIRO não vem na API, verificar a coluna na SC7 que representa essa informação */ }
                                            <td>{ item.COND_PAGTO }</td>
                                            <td>{ item.CTA_CONTABIL ? item.CTA_CONTABIL : ' - ' }</td>
                                            <td>{ item.USUARIO_INC }</td>
                                            <td>VERIFICAR</td>
                                            <td>VERIFICAR</td>
                                            <td>VERIFICAR</td>
                                            <td>{ item.QTD_ENTREGUE }</td>
                                            <td>{ item.RESID_ELIM ? item.RESID_ELIM : ' - ' }</td>
                                            <td>{ item.GRUPO_APROV ? item.GRUPO_APROV : ' - ' }</td>
                                            <td>{ item.CTRL_APROV ? item.CTRL_APROV : ' - ' }</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </PaginatedTable>
                    </Body>
                </BodyWrapper>
            </Container>
            {
                isModalOpen('controladoria-filtros') && (
                    <ModalFilters
                        fecharModal={ closeModal }
                        filtros={ filtros }
                        setFiltros={ setFiltros }
                        aplicarFiltros={ aplicarFiltros }
                    />
                )
            }
        </>
    )
}

export default PedidosCompra;